import { motion } from "framer-motion";
import { Boxes, Truck, MapPin, Ship, CalendarClock, BadgePercent } from "lucide-react";
import { stagger, fadeUp } from "@/components/Reveal";

const ITEMS = [
  { icon: Boxes, label: "500+ SKUs In Stock" },
  { icon: Truck, label: "Free Delivery Across Edmonton" },
  { icon: MapPin, label: "Delivery Across Alberta" },
  { icon: Ship, label: "Direct Imports · India & China" },
  { icon: CalendarClock, label: "Flexible Delivery Schedules" },
  { icon: BadgePercent, label: "Price Match & Price Beat" },
];

export default function TrustStats() {
  return (
    <section data-testid="trust-stats" className="relative z-10 -mt-1 bg-forest text-cream">
      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="max-w-[1440px] mx-auto px-5 md:px-10 py-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-7"
      >
        {ITEMS.map(({ icon: Icon, label }) => (
          <motion.div key={label} variants={fadeUp} className="flex items-center gap-3">
            <span className="shrink-0 grid place-items-center h-10 w-10 rounded-xl bg-butter/15 text-butter-deep">
              <Icon className="h-5 w-5" />
            </span>
            <span className="text-sm font-medium leading-tight text-cream/90">{label}</span>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
